import { CSSProperties, memo } from 'react';

import styled from '@mint-lib/styled';

import { VersionsTableRow as VersionsTableRowType } from '../../../../../types/versions.js';
import VersionsTableBodyItem from './VersionsTableBodyItem/VersionsTableBodyItem.jsx';

type Props = {
  row: VersionsTableRowType;
  style: CSSProperties;
};

const VersionsTableRow = memo(({ row, style }: Props) => {
  return (
    <Tr
      {...row.getRowProps({
        style,
      })}
      className="tr"
    >
      {row.cells.map((cell) => (
        <VersionsTableBodyItem
          cell={cell}
          row={row}
          key={`${cell.column.id}${row.id}`}
        />
      ))}
    </Tr>
  );
});

const Tr = styled('div')`
  text-transform: capitalize;

  &:last-child {
    position: relative;
    border-right: unset;
  }
`;

export default VersionsTableRow;
